import {
  LearningCourse,
  LearningCourseInput
} from '@/core/domain/learning/course/LearningCourse.ts'
import type { ILearningCourseRepository } from '@/core/domain/learning/course/ILearningCourseRepository.ts'

export class CreateLearningCourseUseCase {
  private repository: ILearningCourseRepository

  constructor(repository: ILearningCourseRepository) {
    this.repository = repository
  }

  async execute(courseInput: LearningCourseInput): Promise<LearningCourse> {
    return await this.repository.createLearningCourse(courseInput)
  }
}
